import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { DealEventLogTab } from '@dealstack/frontend/app/pages/Project/DealEventLog/DealEventLog.types.ts';
import { asEnumValue } from '@dealstack/frontend/shared/utils/asEnumValue.ts';

export const parseDealEventLogTab = (value: string | null): DealEventLogTab | undefined =>
	asEnumValue(Object.values(DealEventLogTab), value);

export const DEAL_EVENT_LOG_TAB_LABEL: Readonly<Record<DealEventLogTab, string>> = {
	[DealEventLogTab.ALL_EVENTS]: 'deal_event_log.tab.all_events',
	[DealEventLogTab.INVESTOR_ACTIVITY]: 'deal_event_log.tab.investor_activity',
	[DealEventLogTab.CAPITAL_EVENTS]: 'deal_event_log.tab.capital_events',
	[DealEventLogTab.TEAM_AND_ACCESS]: 'deal_event_log.tab.team_and_access',
	[DealEventLogTab.MESSAGING]: 'deal_event_log.tab.messaging',
};

export const getDealEventLogTabs = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	canReadTeamAndAccess: boolean
): MantineTabProps<DealEventLogTab>[] => {
	const tab = (value: DealEventLogTab, testId: string): MantineTabProps<DealEventLogTab> => ({
		value,
		label: tCapManage(DEAL_EVENT_LOG_TAB_LABEL[value]),
		testId,
	});

	return [
		tab(DealEventLogTab.ALL_EVENTS, 'deal-event-log-tab-all-events'),
		tab(DealEventLogTab.INVESTOR_ACTIVITY, 'deal-event-log-tab-investor-activity'),
		tab(DealEventLogTab.CAPITAL_EVENTS, 'deal-event-log-tab-capital-events'),
		...(canReadTeamAndAccess
			? [tab(DealEventLogTab.TEAM_AND_ACCESS, 'deal-event-log-tab-team-and-access')]
			: []),
		tab(DealEventLogTab.MESSAGING, 'deal-event-log-tab-messaging'),
	];
};
